import * as React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

interface IProps {
    closeButtonText: string;
    onCloseCallback: any;
    openAsDialog: boolean;
    submitButtonText: string;
    onSubmitCallback: any;
    providerName: string; // transunion | experian
    isTuCanadianUser?: boolean;
}
const L3DisclosureComponent: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    let strCloseButtonText = tLang("dashboard.creditScore.l3DisclosureComp.closeButton");
    let strSubmitButtonText = tLang("dashboard.creditScore.l3DisclosureComp.submitButton");
    let blnOpenAsDialog = false;
    const partnerL3DisclaimerText = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerL3DisclaimerText
            ? state.configurationState.configuration.partnerConfig.partnerL3DisclaimerText
            : ""
    );
          // set default value for props, if not passed
    if (props.closeButtonText != null) {
        strCloseButtonText = props.closeButtonText;
    }
    if (props.submitButtonText != null) {
        strSubmitButtonText = props.submitButtonText;
    }
    if (props.openAsDialog != null) {
        blnOpenAsDialog = props.openAsDialog;
    }

    // in case of dialog, register event for escape press
    if (blnOpenAsDialog) {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                window.removeEventListener("keyup", () => {});
                onClose("cancel");
            }
        });
    }

    const invokePostSubmitCallback = (status: string, data: any) => {
        if (props.onSubmitCallback != null) {
            props.onSubmitCallback({ status: status, data: data });
        }
    };

    const onSubmit = () => {
        // TODO: Make an API call to save the user agree click on database for EZS
        invokePostSubmitCallback("success", "Agreed by user");
    };

    const onClose = (reason?: string) => {
        // execute method passed as props for onCloseButtonClick
        if (props.onCloseCallback != null) {
            props.onCloseCallback({ reason: reason == null ? "close" : "cancel" });
        }
    };
    const renderDisclosureText = () => {
        let disclosureText;
        if (partnerL3DisclaimerText) {
            disclosureText = <p>{partnerL3DisclaimerText}</p>;
        } else {
            if (props.isTuCanadianUser) {
                disclosureText = <p>{tLang("dashboard.creditScore.l3DisclosureComp.tuCanadianUser")}</p>;
            } else {
                disclosureText = <p>{tLang("dashboard.creditScore.l3DisclosureComp.nonTuCanadianUser")}</p>;
            }
        }
        return disclosureText;
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                {props.openAsDialog && (
                    <React.Fragment>
                        <div className="dialog-icon status-default">
                            <em className="las la-file-contract"></em>
                        </div>
                        <h1>{tLang("dashboard.creditScore.l3DisclosureComp.header")}</h1>
                    </React.Fragment>
                )}

                {!props.openAsDialog && (
                    <h1>
                        <span className="dialog-icon status-default">
                            <em className="las la-file-contract"></em>
                        </span>{" "}
                        &nbsp; {tLang("dashboard.creditScore.l3DisclosureComp.header")}
                    </h1>
                )}
            </div>

            <div className="dialog-body">{renderDisclosureText()}</div>

            <div className="dialog-footer">
               
                    <div className="row between-xs">
                    
                     <div className="col-xs col-no-gutter flex-grow-null">
                      </div>
                     
                   
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={onSubmit}>
                            <span className="btn-text">{strSubmitButtonText}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default L3DisclosureComponent;
